<template>
  <div class="services">
    <div class="addSeviceBtn">
      <button type="button" class="btn btn-add" @click="resetForm2">
        Add new product
      </button>
    </div>

    <div class="rowInputs" v-if="showServiceForm">
      <div class="rowOne">
        <div class="form-group">
          <label>name:</label>
          <div>
            <input
              type="text"
              placeholder="Entrez le nom du produit"
              class="form-control"
              v-model="name"
              :disabled="showWatchServiceForm"
            />
          </div>
        </div>
        <div class="form-group">
          <label>Currency:</label>
          <div>
            <select
              class="form-select"
              aria-label="Default select example"
              v-model="selectedCurrency"
            >
              <option selected></option>
              <option v-for="(currency, index) in currencies" :key="index">
                {{ currency.CurrencyCode }} - {{ currency.CurrencyName }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label>price:</label>
          <div>
            <input
              type="Number"
              placeholder="Entrez le prix"
              class="form-control"
              v-model="price"
              :disabled="showWatchServiceForm"
            />
          </div>
        </div>
        <div class="form-group">
          <label>Product icon:</label>
          <div>
            <input
              type="file"
              class="form-control"
              @change="setImage"
              :disabled="showWatchServiceForm"
            />
          </div>
        </div>
      </div>
      <div class="rowTwo">
        <div class="form-group">
          <label>Description:</label>
          <div>
            <textarea
              type="text"
              placeholder="Entrez une courte description"
              class="form-control"
              rows="12"
              v-model="description"
              :disabled="showWatchServiceForm"
            ></textarea>
          </div>
        </div>
      </div>
    </div>

    <button
      type="button"
      class="btn btn-add"
      v-if="
        showServiceForm &&
        !showEditeServiceForm &&
        !showWatchServiceForm &&
        !activeSpinner
      "
      @click="addNewService"
    >
      Save
    </button>
    <button
      type="button"
      class="btn btn-add"
      v-if="showEditeServiceForm && !showWatchServiceForm && !activeSpinner"
      @click="updateService"
    >
      Edite
    </button>

    <div class="spinner-grow" role="status" v-if="activeSpinner">
      <span class="sr-only">Loading...</span>
    </div>

    <div class="servicesList">
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Icon</th>
              <th scope="col">Name</th>
              <th scope="col">Currency</th>
              <th scope="col">price</th>
              <th scope="col" style="width: 20%">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(servicesData, index) in servicesData" :key="index">
              <th scope="row">{{ index }}</th>
              <td>
                <img
                  :src="api.img + '/' + servicesData.productIcon"
                  alt="icone"
                  v-if="servicesData.productIcon && servicesData.productIcon != ''"
                />
              </td>
              <td>{{ servicesData.name }}</td>
              <td>{{ servicesData.currency }}</td>
              <td>{{ servicesData.price }}</td>
              <td>
                <div class="icons">
                  <img
                    src="./../../../../src/assets/img/icons/publicIco/eye-open-svgrepo-com.svg"
                    alt="eyes"
                    @click="getUpdateServiceData(servicesData, true)"
                  />
                  <img
                    src="./../../../../src/assets/img/icons/publicIco/edit-svgrepo-com.svg"
                    alt="edit"
                    @click="getUpdateServiceData(servicesData, false)"
                  />
                  <img
                    src="./../../../../src/assets/img/icons/publicIco/delete-remove-fill-svgrepo-com.svg"
                    alt="delete"
                    @click="deleteService(servicesData._id)"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import APIs from "./../../../../config";
export default {
  data() {
    return {
      showServiceForm: false,
      showEditeServiceForm: false,
      showWatchServiceForm: false,

      name: "",
      selectedCurrency: "",
      price: 0,
      serviceIcon: null,
      description: "",

      servicesData: null,
      api: {
        url: APIs.API_URL,
        img: APIs.API_IMAGES,
      },

      get_token: localStorage.getItem("admin_token"),
      user_id: localStorage.getItem("admin_id"),

      serviceID: null,
      currencies: null,

      activeSpinner: false,
    };
  },
  props: {
    cardInfo: Object,
  },
  created() {
    console.log("prestation de service: ", this.cardInfo._id);
    this.getServices();
    this.getCurrencies();
  },
  methods: {
    getCurrencies() {
      axios.get(`${APIs.API_URL}/currency/`).then((res) => {
        this.currencies = res.data;
      });
    },
    setImage(event) {
      this.serviceIcon = event.target.files[0];
    },
    addNewService() {
      this.activeSpinner = true;

      const fd = new FormData();
      fd.append("name", this.name);
      fd.append("currency", this.selectedCurrency);
      fd.append("description", this.description);
      fd.append("price", this.price);
      fd.append("productIcon", this.serviceIcon);
      fd.append("fromCardId", this.cardInfo._id);

      axios
        .post(`${APIs.API_URL}/card/admin/cardProduct/${this.user_id}`, fd, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.get_token}`,
          },
        })
        .then(() => {
          this.activeSpinner = false;
          this.$swal.fire({
            position: "top-end",
            icon: "success",
            title: "Added",
            showConfirmButton: false,
            timer: 1500,
          });
          this.resetForm();
        })
        .catch((error) => {
          this.activeSpinner = false;
          this.$swal.fire({
            position: "top-end",
            icon: "error",
            title: error.response.data.error,
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },
    getServices() {
      this.activeSpinner = true;
      axios
        .get(
          `${APIs.API_URL}/card/admin/cardProduct/${this.user_id}/${this.cardInfo._id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.get_token}`,
            },
          }
        )
        .then((res) => {
          this.activeSpinner = false;
          this.servicesData = res.data;
        });
    },
    resetForm() {
      this.getServices();
      this.name = "";
      this.description = "";
      this.serviceIcon = null;
      this.selectedCurrency = "";
      this.price = 0;
      this.showServiceForm = false;
      this.showEditeServiceForm = false;
      this.showWatchServiceForm = false;
    },
    resetForm2() {
      this.getServices();
      this.name = "";
      this.description = "";
      this.serviceIcon = null;
      this.selectedCurrency = "";
      this.price = 0;
      this.showServiceForm = !this.showServiceForm;
      this.showEditeServiceForm = false;
      this.showWatchServiceForm = false;
    },
    deleteService(serviceID) {
      this.$swal({
        position: "center-center",
        text: "Are you sure you want to delete ?",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Deleted",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete(
              `${APIs.API_URL}/card/admin/cardProduct/${this.user_id}/${serviceID}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${this.get_token}`,
                },
              }
            )
            .then(() => {
              this.resetForm();
            });
        }
      });
    },
    async getUpdateServiceData(data, status) {
      this.activeSpinner = true;

        if(this.serviceIcon && this.serviceIcon != '') {
            const url = APIs.API_IMAGES + "/" + data.productIcon;
            const fileName = "myFile.jpg";
            await fetch(url).then(async (response) => {
                const contentType = response.headers.get("content-type");
                const blob = await response.blob();
                const file = new File([blob], fileName, {
                contentType,
                type: "image/jpeg",
                });
                // access file here
                this.serviceIcon = file;
            });
        }
        else {
            this.serviceIcon = ""
        }

      this.showServiceForm = true;
      this.showEditeServiceForm = true;

      this.name = data.name;
      this.description = data.description;
      this.serviceID = data._id;
      this.selectedCurrency = data.currency;
      this.price = data.price;

      this.showWatchServiceForm = status;

      this.activeSpinner = false
    },
    updateService() {
      this.activeSpinner = true;

      const fd = new FormData();
      fd.append("name", this.name);
      fd.append("currency", this.selectedCurrency);
      fd.append("description", this.description);
      fd.append("price", this.price);
      fd.append("productIcon", this.serviceIcon);

      axios
        .put(
          `${APIs.API_URL}/card/cardProduct/${this.user_id}/${this.serviceID}`,
          fd,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.get_token}`,
            },
          }
        )
        .then(() => {
          this.activeSpinner = false;
          this.$swal.fire({
            position: "top-end",
            icon: "success",
            title: "Updated",
            showConfirmButton: false,
            timer: 1500,
          });
          this.resetForm();
        })
        .catch((error) => {
          this.activeSpinner = false;
          this.$swal.fire({
            position: "top-end",
            icon: "error",
            title: error.response.data.error,
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
.services {
  background-color: white;
  padding: 2% 6%;
  border-radius: 10px;
  margin: 0% 5%;
  .rowInputs {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    width: 100%;
    .rowOne {
        width: 50%;
        .form-group {
            width: 80%;
        }
    }
    .rowTwo {
        width: 50%;
        .form-group {
            width: 80%;
        }
    }
  }
  .addSeviceBtn {
    display: flex;
    justify-content: flex-end;
  }
  .servicesList {
    table {
      tbody {
        tr {
          td {
            .icons {
              display: flex;
              justify-content: space-around;
              img {
                width: 30px;
                cursor: pointer;
              }
            }
          }
          img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
          }
        }
      }
    }
  }
}
</style>
